<template>
    <form method="post" autocomplete="off" enctype="multipart/form-data" @submit.prevent="handleSubmit">
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="password">Password</label>
                    <input type="password" v-model="form.password" id="confirmPassword" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && v$.form.password.$error }" />
                    <span class="text-danger" v-if="v$.form.password.$errors"> {{ v$.form.password.$errors[0]?.$message }} </span>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="confirm_password">Confirm Password</label>
                    <input type="password" v-model="form.confirm_password" id="confirmPassword" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && v$.form.confirm_password.$error }" />
                    <span class="text-danger" v-if="v$.form.confirm_password.$errors"> {{ v$.form.confirm_password.$errors[0]?.$message }} </span>
                </div>
            </div>
        </div>
        <button type="submit" class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right">Update Password</button>
        
    </form>
</template>

<script>
import {computed} from 'vue';
import { useStore } from "vuex"
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
    props: ['modalData'],
	emits: ['closeModal'],
	components: {
	},
    setup(){
		const store = useStore();

        let user = computed(function () { return store.state.user });
        
        function updatePassword(form) {
            store.dispatch("updatePassword", form);
        }

		return {
            user,
            updatePassword
		}
	}, 
	data() {
		return {
            v$: useVuelidate(),
            form: {
                id: null,
                password: null,
                confirm_password: null,
            },
            submitted: false,
		}
	},
    validations() {
        return {
            form: {
                password: { 
                    required,
                    minLength: minLength(10) 
                },
                confirm_password: { 
                    required,
                    sameAsPassword: sameAs(this.form.password) 
                }
            }
        }
    },
    mounted() {
        this.clearFields();
        this.populateData();
    },
	methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate() 
            if (!this.v$.$error) {
                // if ANY fail validation
                this.updatePassword(this.form);
                this.$emit('closeModal')
                window.emitter.emit("alertSuccess", {message: 'Password updated successfully!'});

            } else {
                // alert('Form failed validation')
            }
        },
        populateData() {
            this.form.id = this.modalData.id;
            // this.form.password = this.modalData.password;
        },
        clearFields() {
            this.form.password = null;
            this.form.confirm_password = null;
        }
	}
}
</script>
